import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a1f57964"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "relationship-card" }
const _hoisted_2 = { class: "related-person drawer-top" }

import { computed, ref, watch } from 'vue'
import { useViewPersonStore } from '@/rd/ViewPersonStore'
import { useDataGroupStore } from '@/gp/DataGroupStore'
import { CompositeId } from '@/rd/CompositeId'
import { LoadMode } from '@/util/AsyncData'
import { ProfileUtils } from './ProfileUtils'
import PersonCard from '@/manage/PersonCard.vue'
import ProfileCard from '@/manage/ProfileCard.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileRelationshipCard',
  props: {
    relPersonId: {},
    contextPersonId: {},
    isRelOwner: { type: Boolean },
    ownerOnly: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;



const viewPersonStore = useViewPersonStore()
const dataGroupStore = useDataGroupStore()

const showProfilesRef = ref(false)

const viewPersonRef = computed(() => viewPersonStore.getLoadedPerson(props.relPersonId))
const contextPersonSetsRef = computed(() => {
  if (!props.contextPersonId || !props.relPersonId)
    return []
  const contextGroupId = CompositeId.getGroupId(props.contextPersonId)
  const personSets = viewPersonStore.getAsyncPersonSets(props.relPersonId, LoadMode.EnsureLoaded)?.data
  return personSets?.filter(ps => ps.groupId === contextGroupId && ps.memberIds.some(id => CompositeId.hasGroupId(id, contextGroupId!))) ?? []
})

const profileMemberIdsRef = computed(() => {
  if (!viewPersonRef.value)
    return []
  const dataGroups = dataGroupStore.getLoadedGroupList(viewPersonRef.value.groupIds)
  return ProfileUtils.getNonPlaceholderIds(viewPersonRef.value.matchIds, dataGroups)
})
const contextProfileMemberIdsRef = computed(() => {
  if (!contextPersonSetsRef.value.length)
    return []
  const allMemberIds = contextPersonSetsRef.value.flatMap(ps => ps.memberIds)
  const groupIds = allMemberIds.map(id => CompositeId.getGroupId(id)!)
  const dataGroups = dataGroupStore.getLoadedGroupList(groupIds)
  return ProfileUtils.getNonPlaceholderIds(allMemberIds, dataGroups)
})

function showDimmed(id: string) {
  return !!props.contextPersonId && !isInContextPersonSet(id)
}

function isInContextPersonSet(profileId: string) {
  return CompositeId.hasSameGroupId(profileId, props.contextPersonId) || // research group case
    props.isRelOwner && contextProfileMemberIdsRef.value.includes(profileId)
}

watch(props, () => {
  showProfilesRef.value = false
})

function onSelected() {
  showProfilesRef.value = !showProfilesRef.value
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (profileMemberIdsRef.value.length == 1)
        ? (_openBlock(), _createBlock(ProfileCard, {
            key: 0,
            "person-id": profileMemberIdsRef.value[0],
            "show-profile-type": "",
            dimmed: showDimmed(profileMemberIdsRef.value[0])
          }, null, 8, ["person-id", "dimmed"]))
        : (_openBlock(), _createBlock(PersonCard, {
            key: 1,
            "person-id": props.relPersonId,
            layout: "small",
            "show-profile-type": "",
            "show-profile-count": "multiple",
            "select-mode": "",
            "show-restricted": "",
            dimmed: profileMemberIdsRef.value.every(showDimmed),
            onClick: onSelected
          }, null, 8, ["person-id", "dimmed"]))
    ]),
    (profileMemberIdsRef.value.length > 1)
      ? (_openBlock(), _createElementBlock("ul", {
          key: 0,
          class: _normalizeClass(["list-unstyled profile-list drawer-stack", { show: showProfilesRef.value }])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(profileMemberIdsRef.value, (id) => {
            return (_openBlock(), _createElementBlock("li", { key: id }, [
              _createVNode(ProfileCard, {
                "person-id": id,
                "show-profile-type": "",
                dimmed: showDimmed(id)
              }, null, 8, ["person-id", "dimmed"])
            ]))
          }), 128))
        ], 2))
      : _createCommentVNode("", true)
  ]))
}
}

})